import React, { useEffect, useLayoutEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getSplitTestValue } from '@src/utils/selectors';

import {
    ACTIVATE_BUSINESS_INTRODUCTION,
    SUBMIT_BUSINESS_INTRODUCTION
} from './BusinessIntroduction.actions';
import BusinessType from './BussinessType';
import LimitedCompanyFields from './LimitedCompanyFields';
import limitedCompanyStyles from './LimitedCompanyFields.module.css';
import { getCountryCode } from '../../lendingAPI/lendingAPISelector';
import { getAmplitudeDefaultEventProperties } from '../../tracking/amplitudeEvents';
import commonMessages from '../Containers.messages';

const mapStateToProps = (state) => ({
    countryCode: getCountryCode(state),
    isBusinessDetailsReductionSplitTest:
        getSplitTestValue(state, 'business_details_reduction') &&
        getCountryCode(state) === 'uk'
});

const mapDispatchToProps = {
    activateBusinessIntroduction: () => ({
        type: ACTIVATE_BUSINESS_INTRODUCTION
    }),
    submitBusinessIntroduction: () => ({ type: SUBMIT_BUSINESS_INTRODUCTION })
};

const BusinessIntroduction = ({
    activateBusinessIntroduction,
    submitBusinessIntroduction,
    countryCode,
    isBusinessDetailsReductionSplitTest
}) => {
    useEffect(() => {
        activateBusinessIntroduction();

        tracking.ampli.stepLoaded({
            'Step name': 'Business details',
            ...getAmplitudeDefaultEventProperties()
        });
    }, [activateBusinessIntroduction, countryCode]);

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>
            <h1
                className={classnames(
                    limitedCompanyStyles.businesIntroductionHeader,
                    {
                        [limitedCompanyStyles.businessDetailsReductionHeader]:
                            isBusinessDetailsReductionSplitTest
                    }
                )}>
                <FormattedMessage {...commonMessages.businessIntroduction} />
            </h1>

            {/* TODO: to remove this component when removing redux-forms  */}
            <div className="form-wrapper form-wrapper-hidden">
                <BusinessType formKey="businessType" />
            </div>

            <LimitedCompanyFields
                nextStep={submitBusinessIntroduction}
                formKey="businessTypeFields"
            />
        </React.Fragment>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BusinessIntroduction);
